export default __webpack_public_path__ + "static/media/web3Banner.ca72ab99.jpg";